import { Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { ModalCookiePreferenceComponent } from '../modal-cookie-preference/modal-cookie-preference.component';
import { Team } from '@app/shared/models/team';
import { DialogService } from '@ngneat/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { hostnameIsFromMainDomain } from '@app/shared/helpers/location';


@Component({
  selector: 'app-smash-burger-menu',
  templateUrl: './smash-burger-menu.component.html',
  styleUrls: ['./smash-burger-menu.component.scss']
})
export class SmashBurgerMenuComponent implements OnDestroy {

  @Output() menuToggle: EventEmitter<any> = new EventEmitter<any>();
  @Input() state: boolean;
  @Input() isLoggedIn: boolean;
  @Input() selectedTeam: Team;
  @Input() color?: string;
  @Input() shadowEnabled = true;
  @Input() headerLocation?: string;

  subscriptions: Subscription[] = [];
  burgerToggled: boolean;
  isMainDomain: boolean;
  version: string;

  constructor(
    private router: Router,
    private dialog: DialogService,
  ) {

    this.isMainDomain = hostnameIsFromMainDomain(window.location.hostname);
    this.version = environment.version;
  }

  openCookiePreference(event) {
    this.toggleBurgerMenu(event);
    this.dialog.open(ModalCookiePreferenceComponent, {
      closeButton: false,
      enableClose: false,
      size: 'sm',
      width: '600px',
      data: {
        cancelable: true,
      },
    });
  }

  toggleBurgerMenu(event) {
    this.burgerToggled = !this.burgerToggled;
    this.menuToggle.emit({ toggled: this.burgerToggled, event });
    event.stopPropagation();
    return false;
  }

  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (event.target.classList.contains('overlay-menu')) {
      this.burgerToggled = false;
      this.menuToggle.emit({ toggled: this.burgerToggled, event });
    }
  }

  redirectToSignin() {
    const regexpSmashDomain = /fromsmash.com|fromsmash.ninja/;
    const customCNAME = window.location.hostname.match(regexpSmashDomain) ? false : true;
    if (customCNAME) {
      window.location.href = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}/signin`;
    } else {
      this.router.navigateByUrl('/signin');
    }
  }

  ngOnDestroy() {
    this.burgerToggled = false;
    this.menuToggle.emit({ toggled: this.burgerToggled });
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
